export default {
  clientSummaries: []
}
